var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as reportActions from 'action/report';
import * as commercialManagementActions from 'action/commercialManagement';
import CommonReport from 'component/newCommonReport/newCommonReport';
import columns from './columns';
import { formatColumnsByType } from 'utils/formatColumnsByType';
import priceColumns from './priceColumns';
import sellColumns from './sellColumns';
import stockColumns from './stockColumns';
import expositionColums from './expositionColums';
import moment from 'moment';
import { isEmpty } from 'utils/validations';
var abortController;
var CommercialManagementType;
(function (CommercialManagementType) {
    CommercialManagementType[CommercialManagementType["PRICE"] = 0] = "PRICE";
    CommercialManagementType[CommercialManagementType["STOCK"] = 1] = "STOCK";
    CommercialManagementType[CommercialManagementType["SELL"] = 2] = "SELL";
    CommercialManagementType[CommercialManagementType["EXPOSITION"] = 3] = "EXPOSITION";
})(CommercialManagementType || (CommercialManagementType = {}));
var CommercialManagementNew = function (_a) {
    var auth = _a.auth, translate = _a.translate, fetchCommercialManagementsReport = _a.fetchCommercialManagementsReport, record = _a.record, error = _a.error, fetchFluxReport = _a.fetchFluxReport;
    var _b = useState({}), formData = _b[0], setFormData = _b[1];
    var _c = useState(columns), tableColumns = _c[0], setTableColumns = _c[1];
    var _d = useState(false), breakWord = _d[0], setBreakWord = _d[1];
    var _e = useState([]), graphData = _e[0], setGraphData = _e[1];
    var _f = useState(""), title = _f[0], setTitle = _f[1];
    var _g = useState(), cdLm = _g[0], setCdLm = _g[1];
    var _h = useState(), sections = _h[0], setSections = _h[1];
    var relatoryOptions = [
        { label: "Preço", value: CommercialManagementType.PRICE }, { label: "Estoque em loja", value: CommercialManagementType.STOCK }, { label: "Vendas", value: CommercialManagementType.SELL }, { label: "Frente de exposição", value: CommercialManagementType.EXPOSITION }
    ];
    var fields = [
        {
            type: 'select',
            name: 'reportType',
            required: true,
            label: translate('report.type'),
            help_text: "Selecione um tipo de relatório",
            attrs: {},
            options: relatoryOptions,
        },
        {
            type: 'branchs',
            name: 'branchIdList',
            label: translate('irc.store'),
            help_text: translate('field.selectMultiStores'),
            error_text: translate('field_must_be_filled'),
            required: true,
            onChangeValue: function (e) {
                setFormData(__assign(__assign({}, formData), { listRegionsAndBranchs: e.target.value }));
            },
        },
        {
            type: 'sections',
            name: 'sectionIdList',
            hasLmValidation: true,
            label: translate('irc.section'),
            help_text: translate('field.selectMultiSections'),
            error_text: translate('field_must_be_filled'),
            required: false,
            onChangeValue: function (e) {
                setSections(e);
                setFormData(__assign(__assign({}, formData), { sectionInputContent: e }));
            },
            attrs: {
                disabled: Boolean(cdLm) && !isEmpty(cdLm),
            },
        },
        {
            type: 'input',
            name: 'cdLm',
            label: translate('lm_label'),
            help_text: "Digite um LM",
            error_text: translate('field_must_be_filled'),
            required: false,
            onChangeValue: function (e) {
                setCdLm(e.target.value);
                setFormData(__assign(__assign({}, formData), { cdLm: e.target.value }));
            },
            attrs: {
                minLength: 8,
                maxLength: 8,
                mask: '99999999',
                disabled: Boolean(sections)
                    && Object.keys(sections).length > 0,
            },
        },
        {
            type: 'date_range',
            name: 'dtRange',
            label: translate('field.period.hint'),
            help_text: translate('kardex.field.dtRef.placeholder'),
            error_text: translate('field_must_be_filled'),
            required: true,
        },
    ];
    function onExport(callback) {
        var values = {
            tpReport: 40,
        };
        abortController = new AbortController();
        fetchFluxReport(auth.user.dsToken, values, formData, translate, abortController);
        callback();
    }
    function onExportGraph(callback) {
        callback();
    }
    function onSubmit(submitData, setResponseInTable) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedValues;
            return __generator(this, function (_a) {
                formattedValues = __assign(__assign({}, submitData), { dtEnd: submitData.dtRange ? moment(submitData.dtRange[1]).format("L") : '', dtStart: submitData.dtRange ? moment(submitData.dtRange[0]).format("L") : '', hasPagination: true, sectionInputContent: formData.sectionInputContent, size: submitData.limit });
                delete formattedValues.dtRange;
                switch (formattedValues.reportType) {
                    case CommercialManagementType.PRICE:
                        setTitle("Preço");
                        setTableColumns(priceColumns);
                        setBreakWord(false);
                        break;
                    case CommercialManagementType.SELL:
                        setTitle("Vendas");
                        setTableColumns(sellColumns);
                        setBreakWord(false);
                        break;
                    case CommercialManagementType.STOCK:
                        setTitle("Estoque em loja");
                        setTableColumns(stockColumns);
                        setBreakWord(false);
                        break;
                    default:
                        setTitle("Frente de exposição");
                        setTableColumns(expositionColums);
                        setBreakWord(true);
                }
                setFormData(formattedValues);
                abortController = new AbortController();
                fetchCommercialManagementsReport(auth, formattedValues, function (response) {
                    var valuesFormattedByTypes = formatColumnsByType(columns, response.commercialManagement, translate);
                    setResponseInTable({ total: response.pagination.totalCount, data: valuesFormattedByTypes });
                    setGraphData(graphData);
                }, abortController);
                return [2 /*return*/];
            });
        });
    }
    useEffect(function () {
    }, [record, error]);
    return (_jsx(CommonReport, { breakWord: breakWord, title: "Relatório de gestão comercial", onExport: onExport, label: title, onExportGraph: onExportGraph, onSubmit: onSubmit, columns: tableColumns, fields: fields, user: auth.user, limit: 10, translate: translate, emptyReportMsg: 'no.data.found', order: true, defaultOrder: 'date' }));
};
var mapStateToProps = function (_a) {
    var paginateReducer = _a.paginateReducer, commercialManagementReducer = _a.commercialManagementReducer;
    return ({
        record: commercialManagementReducer.reportRecord,
        error: commercialManagementReducer.reportError,
        pages: paginateReducer.pages,
        count: paginateReducer.count,
        current: paginateReducer.current,
    });
};
function mapDispatchToProps(dispatch) {
    return bindActionCreators(__assign(__assign({}, commercialManagementActions), reportActions), dispatch);
}
var CommercialManagementNewTranslated = translate(null, {
    wait: true,
    translateFuncName: 'translate',
})(CommercialManagementNew);
export default connect(mapStateToProps, mapDispatchToProps)(CommercialManagementNewTranslated);
